import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from '../Link'
import Query from './Query'

const FiltersList = styled.ul`
  font-size: 1.6rem;
  text-transform: uppercase;

  li {
    display: inline-block;
    padding: 1rem 0;

    a {
      border-right: 0.1rem solid ${({ theme }) => theme.colors.pageRule};
      padding: 0 2rem;
      color: ${({ theme }) => theme.colors.text};

      &.active,
      &:hover {
        color: ${({ theme }) => theme.colors.interactive};
      }
    }

    &:last-of-type a {
      border-right: none;
    }
  }
`

const FilterAnchors = styled.div`
  position: absolute;
  z-index: -1;
`

const FiltersInner = ({ activeFilter, onChange, content, teamMembers }) => {
  const [filters, setFilters] = useState(getFilters(activeFilter))

  function getFilters() {
    const teamKeys = content.teams.map((team) => team.key)
    const filters = {}
    teamMembers.forEach((member) => {
      if (teamKeys.includes(member.team)) filters[member.team] = true
    })

    return Object.values(content.teams).filter((filter) => filters[filter.key])
  }

  useEffect(() => {
    setFilters(getFilters(activeFilter))
  }, [activeFilter])

  const handleClick = (filter) => (e) => {
    e.preventDefault()
    onChange(filter)
  }

  return (
    <Fragment>
      <FiltersList>
        <li>
          <Link
            tracking={{ label: 'team_page_filter_iohk' }}
            href="#"
            onClick={handleClick('')}
            className={!activeFilter ? 'active' : ''}
          >
            <strong>IOHK</strong>
          </Link>
        </li>
        {filters.map((filter) => (
          <li key={filter.key}>
            <Link
              tracking={{ label: `team_page_filter_${filter.key}` }}
              href="#"
              onClick={handleClick(filter.key)}
              className={filter.key === activeFilter ? 'active' : ''}
            >
              <strong>{filter.label}</strong>
            </Link>
          </li>
        ))}
      </FiltersList>
      <FilterAnchors ariaHidden>
        {filters.map((filter) => (
          <div id={filter.key} key={filter.key} />
        ))}
      </FilterAnchors>
    </Fragment>
  )
}

FiltersInner.propTypes = {
  activeFilter: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

const Filters = ({ activeFilter, onChange }) => (
  <Query
    render={({ content, teamMembers }) => (
      <FiltersInner
        activeFilter={activeFilter}
        onChange={onChange}
        content={content}
        teamMembers={teamMembers}
      />
    )}
  />
)

Filters.propTypes = {
  activeFilter: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default Filters
